<template>
    <div>
        <h3 class="mb-3 text-[13px] font-medium text-theme-text">
            {{ localizations[lang].lineSpacing }}
        </h3>
        <div class="flex gap-1.5">
            <SettingsButton
                variant="icon"
                :is-active="selectedValue === options[0].value"
                :aria-label="localizations[lang][options[0].labelKey]"
                @click="selectOption(options[0])"
            >
                <svg aria-hidden="true" width="24" height="18" viewBox="0 0 24 18" fill="none">
                    <rect x="4" y="3" width="16" height="2" rx="1" fill="currentColor"></rect>
                    <rect x="4" y="8" width="16" height="2" rx="1" fill="currentColor"></rect>
                    <rect x="4" y="13" width="16" height="2" rx="1" fill="currentColor"></rect>
                </svg>
            </SettingsButton>
            <SettingsButton
                variant="icon"
                :is-active="selectedValue === options[1].value"
                :aria-label="localizations[lang][options[1].labelKey]"
                @click="selectOption(options[1])"
            >
                <svg aria-hidden="true" width="24" height="18" viewBox="0 0 24 18" fill="none">
                    <rect x="4" y="1" width="16" height="2" rx="1" fill="currentColor"></rect>
                    <rect x="4" y="8" width="16" height="2" rx="1" fill="currentColor"></rect>
                    <rect x="4" y="15" width="16" height="2" rx="1" fill="currentColor"></rect>
                </svg>
            </SettingsButton>
            <SettingsButton
                variant="icon"
                :is-active="selectedValue === options[2].value"
                :aria-label="localizations[lang][options[2].labelKey]"
                @click="selectOption(options[2])"
            >
                <svg aria-hidden="true" width="24" height="18" viewBox="0 0 24 18" fill="none">
                    <rect x="4" y="-1.5" width="16" height="2" rx="1" fill="currentColor"></rect>
                    <rect x="4" y="8" width="16" height="2" rx="1" fill="currentColor"></rect>
                    <rect x="4" y="17.5" width="16" height="2" rx="1" fill="currentColor"></rect>
                </svg>
            </SettingsButton>
        </div>
    </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import {
    LINE_HEIGHT_COMPACT,
    LINE_HEIGHT_DEFAULT,
    LINE_HEIGHT_NORMAL,
    LINE_HEIGHT_WIDE,
} from '../../../../src/js/components/partials/Epub/Readium/readium2-styles';
import SettingsButton from './SettingsButton.vue';

const LINE_HEIGHT_OPTIONS = [
    { value: LINE_HEIGHT_COMPACT, labelKey: 'lineSpacingCompact' },
    { value: LINE_HEIGHT_NORMAL, labelKey: 'lineSpacingNormal' },
    { value: LINE_HEIGHT_WIDE, labelKey: 'lineSpacingWide' },
];

export default {
    name: 'LineSpacingSelector',
    components: {
        SettingsButton,
    },
    computed: {
        ...mapState(['localizations', 'lang', 'userSettings']),

        options() {
            return LINE_HEIGHT_OPTIONS;
        },

        selectedValue() {
            return this.userSettings.epub.lineHeight ?? LINE_HEIGHT_DEFAULT;
        },
    },
    methods: {
        ...mapActions(['saveUserSettings']),

        selectOption(option) {
            if (option.value === this.selectedValue) return;
            this.$bus.$emit('lineHeight', option.value);
            this.saveUserSettings({ lineHeight: option.value });
        },
    },
};
</script>
